import { render, staticRenderFns } from "./StudentEditConfirm.vue?vue&type=template&id=8334fdba&scoped=true"
import script from "./StudentEditConfirm.vue?vue&type=script&lang=ts"
export * from "./StudentEditConfirm.vue?vue&type=script&lang=ts"
import style0 from "./StudentEditConfirm.vue?vue&type=style&index=0&id=8334fdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8334fdba",
  null
  
)

export default component.exports